export const adminTheme = {
    colors: {
        lightRed: "#FFC1C1",
        red: "#C94343",
        darkRed: "#A50000",
    },
};
